<template>
  <div class="zfb-link-container">
    <el-card class="container-card" shadow="hover">
      <el-form :inline="true" :model="searchForm" label-position="right" label-width="80px" class="search-form"
               style="display: flex; align-items: center; flex-wrap: nowrap; gap: 10px; overflow-x: auto;">

        <el-form-item>
          <el-button type="primary" size="small" @click="handleAdd">添加链接</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="small" @click="handleBatchAdd">批量添加链接</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" size="small" @click="batchEnable" :disabled="selection.length === 0">
            批量开启({{selection.length}})
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="warning" size="small" @click="batchDisable" :disabled="selection.length === 0">
            批量暂停({{selection.length}})
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="info" size="small" @click="batchAddCount" :disabled="selection.length === 0">
            批量加次数({{selection.length}})
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="danger" size="small" @click="batchDelete" :disabled="selection.length === 0">
            批量删除({{selection.length}})
          </el-button>
        </el-form-item>
      </el-form>

      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.7)"
        class="data-table"
        @selection-change="handleSelectionChange">

        <el-table-column type="selection" width="55" align="center"></el-table-column>

        <el-table-column prop="id" label="ID" width="80" align="center" header-align="center"></el-table-column>
        <el-table-column prop="kehu" label="客户" width="120" align="center" header-align="center"></el-table-column>
        <el-table-column prop="link" label="链接" min-width="300" align="center" header-align="center"></el-table-column>
        <el-table-column prop="count" label="已访问次数" width="120" align="center" header-align="center"></el-table-column>
        <el-table-column prop="totalCount" label="总访问次数" width="120" align="center" header-align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center" header-align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '已启用' : '未启用' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="300" align="center" header-align="center">
          <template slot-scope="scope">
            <el-button size="mini" :type="scope.row.status === 1 ? 'warning' : 'success'" @click="toggleStatus(scope.row)" plain>
              {{ scope.row.status === 1 ? '暂停' : '启用' }}
            </el-button>
            <el-button size="mini" type="primary" @click="editLink(scope.row)" plain>编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteLink(scope.row)" plain>删除</el-button>
            <el-button size="mini" type="info" @click="copyLink(scope.row)" plain>复制链接</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          background small>
        </el-pagination>
      </div>

      <!-- 添加/编辑链接对话框 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%" @close="handleDialogClose">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
          <el-form-item label="链接" prop="link">
            <el-input v-model="form.link" placeholder="请输入链接" :disabled="isEditMode"></el-input>
          </el-form-item>
          <el-form-item label="客户" prop="kehu">
            <el-input v-model="form.kehu" placeholder="请输入客户" :disabled="isEditMode"></el-input>
          </el-form-item>
          <el-form-item label="总访问次数" prop="totalCount">
            <el-input-number v-model="form.totalCount" :min="1" placeholder="请输入总访问次数"></el-input-number>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio :label="0">不启用</el-radio>
              <el-radio :label="1">启用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="handleSubmit" size="small">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 批量添加链接对话框 -->
      <el-dialog title="批量添加链接" :visible.sync="batchAddDialogVisible" width="50%">
        <el-form label-width="100px" size="small">
          <el-form-item label="链接列表">
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入链接，每行一个"
              v-model="batchLinks">
            </el-input>
          </el-form-item>
          <el-form-item label="客户">
            <el-input v-model="batchForm.kehu" placeholder="请输入客户"></el-input>
          </el-form-item>
          <el-form-item label="总访问次数">
            <el-input-number v-model="batchForm.totalCount" :min="1"></el-input-number>
          </el-form-item>
          <el-form-item label="状态">
            <el-radio-group v-model="batchForm.status">
              <el-radio :label="0">不启用</el-radio>
              <el-radio :label="1">启用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="batchAddDialogVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="confirmBatchAdd" size="small">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 批量加次数对话框 -->
      <el-dialog title="批量加次数" :visible.sync="batchAddCountDialogVisible" width="30%">
        <el-form label-width="100px" size="small">
          <el-form-item label="增加次数">
            <el-input-number v-model="addCountValue" :min="1"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="batchAddCountDialogVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="confirmBatchAddCount" size="small">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { get, post } from '../../until/controlRequest'

export default {
  name: 'ZfbLink',
  data() {
    return {
      searchForm: {},
      tableData: [],
      loading: false,
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      batchAddDialogVisible: false,
      batchAddCountDialogVisible: false,
      dialogTitle: '添加链接',
      form: {
        id: null,
        link: '',
        kehu: '',
        totalCount: 100,
        status: 1
      },
      rules: {
        link: [
          { required: true, message: '请输入链接', trigger: 'blur' }
        ],
        kehu: [
          { required: true, message: '请输入客户', trigger: 'blur' }
        ],
        totalCount: [
          { required: true, message: '请输入总访问次数', trigger: 'blur' }
        ]
      },
      isEditMode: false,
      selection: [],
      batchLinks: '',
      batchForm: {
        kehu: '',
        totalCount: 100,
        status: 1
      },
      addCountValue: 100
    }
  },
  created() {
    this.fetchPage()
  },
  methods: {
    handleSelectionChange(val) {
      this.selection = val
    },

    handleAdd() {
      this.dialogTitle = '添加链接'
      this.form = {
        id: null,
        link: '',
        totalCount: 100,
        status: 1
      }
      this.isEditMode = false
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },

    handleBatchAdd() {
      this.batchLinks = ''
      this.batchForm = {
        totalCount: 100,
        status: 1
      }
      this.batchAddDialogVisible = true
    },

    editLink(row) {
      this.dialogTitle = '编辑链接'
      this.form = {
        id: row.id,
        link: row.link,
        kehu: row.kehu,
        totalCount: row.totalCount,
        status: row.status
      }
      this.isEditMode = true
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },

    toggleStatus(row) {
      const newStatus = row.status === 1 ? 0 : 1
      post('/v1/zfb/link/update', {
        id: row.id,
        status: newStatus
      }).then(() => {
        this.$message.success(`${newStatus === 1 ? '启用' : '暂停'}成功`)
        this.fetchPage()
      }).catch(() => {
        this.$message.error(`${newStatus === 1 ? '启用' : '暂停'}失败`)
      })
    },

    batchEnable() {
      if (this.selection.length === 0) {
        this.$message.warning('请至少选择一条记录')
        return
      }

      const ids = this.selection.map(item => item.id)
      post('/v1/zfb/link/batchEnable', ids)
        .then(() => {
          this.$message.success('批量启用成功')
          this.fetchPage()
          this.selection = []
        })
        .catch(() => {
          this.$message.error('批量启用失败')
        })
    },

    batchDisable() {
      if (this.selection.length === 0) {
        this.$message.warning('请至少选择一条记录')
        return
      }

      const ids = this.selection.map(item => item.id)
      post('/v1/zfb/link/batchDisable', ids)
        .then(() => {
          this.$message.success('批量暂停成功')
          this.fetchPage()
          this.selection = []
        })
        .catch(() => {
          this.$message.error('批量暂停失败')
        })
    },

    batchAddCount() {
      if (this.selection.length === 0) {
        this.$message.warning('请至少选择一条记录')
        return
      }
      this.addCountValue = 100
      this.batchAddCountDialogVisible = true
    },

    confirmBatchAddCount() {
      const params = this.selection.map(item => ({
        id: item.id,
        totalCount: this.addCountValue
      }))

      post('/v1/zfb/link/batchUpdateTotalCount', params)
        .then(() => {
          this.$message.success('批量加次数成功')
          this.fetchPage()
          this.batchAddCountDialogVisible = false
          this.selection = []
        })
        .catch(() => {
          this.$message.error('批量加次数失败')
        })
    },

    batchDelete() {
      if (this.selection.length === 0) {
        this.$message.warning('请至少选择一条记录')
        return
      }

      this.$confirm(`确定要删除选中的 ${this.selection.length} 条链接吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const ids = this.selection.map(item => item.id)
        post('/v1/zfb/link/batchDelete', ids)
          .then(() => {
            this.$message.success('批量删除成功')
            this.fetchPage()
            this.selection = []
          })
          .catch(() => {
            this.$message.error('批量删除失败')
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    confirmBatchAdd() {
      if (!this.batchLinks.trim()) {
        this.$message.warning('请输入链接')
        return
      }

      const links = this.batchLinks.split('\n').filter(link => link.trim() !== '')
      if (links.length === 0) {
        this.$message.warning('请输入有效的链接')
        return
      }

      const params = links.map(link => ({
        link: link.trim(),
        kehu: this.batchForm.kehu,
        totalCount: this.batchForm.totalCount,
        status: this.batchForm.status
      }))

      post('/v1/zfb/link/batchInsert', params)
        .then(() => {
          this.$message.success('批量添加成功')
          this.fetchPage()
          this.batchAddDialogVisible = false
        })
        .catch(() => {
          this.$message.error('批量添加失败')
        })
    },

    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return

        const api = this.form.id ? '/v1/zfb/link/update' : '/v1/zfb/link/insert'
        post(api, this.form)
          .then(() => {
            this.$message.success(this.form.id ? '更新成功' : '添加成功')
            this.dialogVisible = false
            this.fetchPage()
          })
          .catch(() => {
            this.$message.error(this.form.id ? '更新失败' : '添加失败')
          })
      })
    },

    deleteLink(row) {
      this.$confirm(`确定要删除链接 "${row.link}" 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        post(`/v1/zfb/link/delete?id=${row.id}`)
          .then(() => {
            this.$message.success('删除成功')
            this.fetchPage()
          })
          .catch(() => {
            this.$message.error('删除失败')
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    copyLink(row) {
      const link = `alipays://platformapi/startapp?appId=2021005182609953&page=pages/index/index&query=kehu%3D${row.kehu}`;
      const textarea = document.createElement('textarea');
      textarea.value = link;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.$message.success('复制成功');
    },

    fetchPage() {
      this.loading = true
      const params = {
        current: this.pagination.current,
        size: this.pagination.size
      }
      get('/v1/zfb/link/page', params)
        .then(data => {
          this.tableData = data.records || []
          this.pagination.total = data.total || 0
        })
        .catch(() => {
          this.tableData = []
          this.pagination.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleDialogClose() {
      this.$refs.form && this.$refs.form.resetFields()
    },

    handleSizeChange(val) {
      this.pagination.size = val
      this.fetchPage()
    },

    handleCurrentChange(val) {
      this.pagination.current = val
      this.fetchPage()
    }
  }
}
</script>

<style scoped>
.zfb-link-container {
  padding: 20px;
}

.container-card {
  min-height: calc(100vh - 90px);
}

.search-form {
  margin-bottom: 20px;
}

.data-table {
  margin-bottom: 20px;
}

.pagination-container {
  text-align: center;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/zfb/ZfbLink.vue